import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import MotionWrapper from '../../component/MotionWrapper';
import axios from 'axios';
import Letter from '../../component/Spring/Letter';
import Dday_Spring from '../../component/Spring/Dday_Spring';
import Message_Spring from '../../component/Spring/Message_Spring';
import Location_Spring from '../../component/Spring/Location_Spring';
import Footer from '../../component/Footer';
import Loading from '../../component/Loading';
import Location_Desc from '../../component/Location/Location_Desc';
import Music from '../../component/Music';
import AccountList from '../../component/Account/AccountList';
import Sharing from '../../component/Sharing';
import GalleryList from '../../component/Gallery/GalleryList';
import Main_Summer from '../../component/Summer/Main_Summer';
import Save_Date from '../../component/Save_Date';
import Info_Spring from '../../component/Spring/Info_Spring';
import Interview_Spring from '../../component/Spring/Interview_Spring';
import CallInfo from '../../component/CallInfo';
import Information from '../../component/Information';
import Info_Spring2 from '../../component/Spring/Info_Spring2';
import AccountList2 from '../../component/Account/AccountList2';
import musicTitle from '../../asset/music/eunSeon.mp3'

const BaeEunSeon = () => {
    const navigate = useNavigate(); 
    const { mainPage } = useParams();

    const API_URL = process.env.REACT_APP_API_URL;

    const [loading, setLoading] = useState(true);
    const [fontsLoaded, setFontsLoaded] = useState(false);

    const openTitle = "정민우♥배은선 결혼합니다";
    const openDesc = "8월 30일 11시 50분 더웨스틴헤라";
    const openThumb = "https://d39wt6wnedokd1.cloudfront.net/263/thumb.jpg";

    const lng = 127.093159044876;
    const lat = 35.7982142717453;

    const placeTelNum = "0507-1473-9065";

    const forBus = "국립전주박물관 또는 완산고 입구 정류장 하차\nㆍ도보로 5분거리\nㆍ경유노선 3002, 19, 62, 112, 131, 149,\n  554, 559, 644, 684, 685, 999(외곽방향)";
    const forCar = "내비게이션에 '엔타워컨밴션웨딩홀' 로 검색하여 오시면\n 바로 옆에 신관 '더웨스틴헤라' 건물이 \n있습니다"
    const forTaxi = "ㆍ전주역에서 약 30분\nㆍ고속 · 시외버스터미널에서 약 20분 거리"

    const [weddingData, setWeddingData] = useState({
        id:'',
        concept: '',
        weddingDate: '',
        invitationInfoId: '',
        brideName: '',
        groomName: '',
        brideNameEn: '',
        groomNameEn: '',
        year:'',
        month:'',
        date:'',
        dayOfWeek:'',
        time:'',
        place:'',
        address:'',
        mainImg:'',
        subImg:'',
        pointColor: '',
        btnFontColor: '',
        btnBgColor: '',
        isGuestBookOpen: ''
    });


    const conceptStyle = {
        // summer 블루
        concept: "SUMMER",
        titleColor: "#505D89",
        pointColor: "#505D89",
        btnBgColor: "#505D89",
        fontColor: "#ffffff",
        btnFontColor: "#ffffff",
        chatBgColor: "#F5F8FF",
        fontFamilyKo: "SCDream3",
        fontFamilyEn: "Edensor"
    }


    const title = "결혼합니다"

    const msg1 = "두 사람의 마음이 만나 하나가 되는 날,\n소중한 분들과 함께 그 시작을 나누고 싶습니다.";
    const msg2 = "귀한 시간 내어 찾아와주신 모든 분들께 깊이 감사드리며,\n이 소중한 인연과 축복을 마음에 새기며,\n서로의 곁에서 늘 따뜻한 사람이 되겠습니다.";


    const parents = [
        {groom : "❁박금주 · 이윤실의 장남"},
        {bride : "이학두 · 최경숙의 차녀"}
    ]

    const groomAccountList = [
        {
            role: "신랑",
            name: "정민우",
            bank: "카카오뱅크",
            accountNumber : "3333-08-8224423",
            isKakao : false
        }
        ,{
            role: "신랑 부",
            name: "정승모",
            bank: "전북은행",
            accountNumber : "506-21-0024867",
            isKakao : false
        }
        ,{
            role: "신랑 모",
            name: "이미화",
            bank: "농협",
            accountNumber : "501052-52-034935",
            isKakao : false
        }
    ]

    const brideAccountList = [
        {
            role: "신부",
            name: "배은선",
            bank: "광주은행",
            accountNumber : "1121-030-404590",
            isKakao : false
        }
        ,{
            role: "신부 부",
            name: "배형기",
            bank: "우리은행",
            accountNumber : "1002-242-490279",
            isKakao : false
        }
        ,{
            role: "신부 모",
            name: "이정란",
            bank: "우리은행",
            accountNumber : "1002-144-949968",
            isKakao : false
        }
    ]

    const account_explain = "따로 계좌번호를 여쭤보시는 수고를 덜기 위해 기입합니다. \n부담 안가지셨으면 좋겠습니다."

    const interviewContent = [
        {
            question : "우리의 설레였던 첫 만남 기억해?",
            groomAnswer: "네게 끌렸어",
            brideAnswer: "운명 같았어"
        },
        {
            question : "결혼을 앞둔 소감이 어때?",
            groomAnswer: "기다렸어",
            brideAnswer: "꿈만 같아"
        },
        {
            question : "서로에게 하고 싶은 말은?",
            groomAnswer: "널 그려왔어",
            brideAnswer: "떨려, 너라서"
        },
        {
            question : "유부남/녀 기념 각오 한마디!",
            groomAnswer: "평생 지켜줄게",
            brideAnswer: "평생 사랑할게"
        },
        {
            question : "마지막으로 전하고 싶은 이야기는?",
            groomAnswer: "영원히 사랑해",
            brideAnswer: "영원히 사랑해"
        },
    ]

    const groomCallInfoList = [
        {
            role: "신랑",
            name: "정민우",
            call: "010-3400-5701"
        }
        ,{
            role: "신랑 부",
            name: "정승모",
            call: "010-9928-5701"
        }
        ,{
            role: "신랑 모",
            name: "이미화",
            call: "010-8640-0073"
        }
    ]

    const brideCallInfoList = [
        {
            role: "신부",
            name: "배은선",
            call: "010-5174-5616"
        }
        ,{
            role: "신부 부",
            name: "배형기",
            call: "010-4622-5616"
        }
        ,{
            role: "신부 모",
            name: "이정란",
            call: "010-4194-5616"
        }
    ]

    const informationList =[
        {
            title : "ATM 기기 안내",
            content : "주변엔 ATM기기가 없습니다. \n이점 양해 부탁드립니다."
        }
    ]

    const fetchInvitationInfoData = async () => {
        try {
            const response = await axios.get(`${API_URL}/_api/v1/invitation_info/${mainPage}`);
            if(response.status === 200){
                const [y, m, d] = response.data.data.weddingDate.split('-');

                setWeddingData(prevData => {
                    const newData = {
                        id: response.data.data.id,
                        concept: response.data.data.concept,
                        weddingDate: response.data.data.weddingDate,
                        invitationInfoId: response.data.data.id,
                        brideName: response.data.data.brideNameKo,
                        groomName: response.data.data.groomNameKo,
                        brideNameEn: response.data.data.brideNameEn,
                        groomNameEn: response.data.data.groomNameEn,
                        year: y,
                        month: m,
                        date: d,
                        dayOfWeek: response.data.data.dayOfWeek,
                        time: response.data.data.time,
                        place: response.data.data.place,
                        address: response.data.data.address,
                        mainImg: response.data.data.mainImg,
                        subImg: response.data.data.subImg,
                        pointColor: response.data.data.pointColor,
                        btnBgColor: response.data.data.btnBgColor,
                        btnFontColor: response.data.data.btnFontColor,
                        isGuestBookOpen: response.data.data.isGuestBookOpen
                    };
                    return newData;
                });
            } 
        } catch (error) {
            console.error("API 요청 실패:", error.response ? error.response.data : error.message);
        }
    };

    useEffect(() => {
        const fetchDataSequentially = async () => {
            if (!weddingData.weddingDate) {  
                await fetchInvitationInfoData();
            }
        };
        fetchDataSequentially();  
    
        document.body.style.overflow = 'hidden';
    
        const timer = setTimeout(() => {
            document.body.style.overflow = '';
        }, 3000);
    
        return () => {
            clearTimeout(timer);
            document.body.style.overflow = '';
        };
    }, []);

    useEffect(() => {
        const fontLoadObserver = async () => {
            await document.fonts.ready; 
            setFontsLoaded(true); 
            setLoading(false);
        };
        if(!weddingData.weddingDate){
            fontLoadObserver();
        }
    }, []);

    const goToGuestBook = () => {
        navigate(`/${mainPage}/guest`); 
    };

    // 성을 제외하고 이름만 추출 ex. 가영
    const getFirstKoName = (fullName) => {
        const nameParts = fullName.split(''); 
        return nameParts.slice(1).join(''); 
    };

    // 성을 제외하고 이름만 추출 ex.Gayeong
    const getFirstNameEn = (fullName) => {
        const nameParts = fullName.split(' '); 
        const firstName = nameParts.slice(1).join(''); 
        return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
    };

    // ex. Kim Gayeong
    const getRemoveSpaceName = (fullName) => {
        const nameParts = fullName.split(' '); // 문자열을 띄어쓰기로 분리
        const firstName = nameParts[0]; // 첫 번째 단어 유지
        const restName = nameParts.slice(1).join(''); // 나머지 단어를 소문자로 변경하고 결합
        return firstName + ' ' + restName.charAt(0).toUpperCase() + restName.slice(1).toLowerCase();
    };

        // 성을 제외하고 이름만 추출 ex.Gayeong
        const getFirstEnName = (fullName) => {
            const nameParts = fullName.split(' '); 
            const firstName = nameParts.slice(1).join(''); 
            return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
        };
        
        // 브라운 #5b0100
        // #761B40
        // #423866
        // #d98db9
        // #FF8A83
    return (
        <div>
            {loading || !fontsLoaded ? (
                <Loading color={"#505D89"} loading={loading} />
            ) : (
                <>
                    <Music concept={conceptStyle.concept} musicTitle={musicTitle}/>
                    <Main_Summer weddingData={weddingData} groomNameEn={getRemoveSpaceName(weddingData.brideNameEn)} brideNameEn={getRemoveSpaceName(weddingData.groomNameEn)} color={"#ffffff"} letteringFontColor={"#ffffff"} dateColor={"#ffffff"} bottom={"22%"} bottom2={"13.2%"} dateBottom={"1%"} top={"3%"}/>
                    <Save_Date color={conceptStyle.pointColor} isBorder={true} marginTop={"100px"} marginBottom={"10px"} fontSize={"13px"} />
                    <Info_Spring2  weddingData={weddingData} conceptStyle={conceptStyle} brideNameEn={getFirstEnName(weddingData.brideNameEn)} groomNameEn={getFirstEnName(weddingData.groomNameEn)}/>
                    <Letter pointColor={"#505D89"} title={title} msg1={msg1} msg2={msg2} conceptStyle={conceptStyle} />
                    <CallInfo marginTop={"0px"} conceptStyle={conceptStyle} groomCallInfoList={groomCallInfoList} brideCallInfoList={brideCallInfoList}/>
                    <Dday_Spring isAttendFromClose={true} brideName={getFirstKoName(weddingData.brideName)} groomName={getFirstKoName(weddingData.groomName)} weddingData={weddingData} conceptStyle={conceptStyle}/>
                    <MotionWrapper initialY={50}>
                        <GalleryList fontFamilyKo={conceptStyle.fontFamilyKo} fontFamilyEn={conceptStyle.fontFamilyEn} color={conceptStyle.titleColor} weddingData={weddingData} initCount={9} photoWidth={"110px"} photoHeight={"150px"} gap={"3px"}/>
                    </MotionWrapper>
                    <MotionWrapper initialY={70}>
                        <AccountList conceptStyle={conceptStyle} groomAccountList={groomAccountList} brideAccountList={brideAccountList} account_explain={account_explain} />
                    </MotionWrapper>
                    <MotionWrapper initialY={70}>
                        <Message_Spring weddingData={weddingData} goToGuestBook={goToGuestBook} weddingDate={weddingData.weddingDate} 
                            conceptStyle={conceptStyle} 
                            btnBgColor={weddingData.btnBgColor} btnFontColor={weddingData.btnFontColor} titleColor={weddingData.titleColor}
                            />
                    </MotionWrapper>
                    <MotionWrapper initialY={50}>
                        {/* <Interview_Spring interviewContent={interviewContent} weddingData={weddingData} conceptStyle={conceptStyle} /> */}
                        <Location_Spring weddingData={weddingData} conceptStyle={conceptStyle} lng={lng} lat={lat} placeTelNum={placeTelNum}/>
                    </MotionWrapper>
                    <Location_Desc forCar={forCar} isPoint={true} forBus={forBus} forTaxi={forTaxi} conceptStyle={conceptStyle}/>
                    <Sharing conceptStyle={conceptStyle} title={openTitle} description={openDesc} thumbImg={openThumb}/>
                    <Footer />
                </>
            )}
        </div>
    );
    
};

export default BaeEunSeon;